import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_PRIORITY_TASK_MUTATION } from '../graphql/mutations'
import { UPDATE_PRIORITY_TASK } from '../redux/action-types'

const useUpdatePriorityTaskMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading, updateError } = useSelector(
    store => store.priorityTasks.priorityTask,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate({
        mutation: UPDATE_PRIORITY_TASK_MUTATION,
        variables: { id, data },
        dispatch,
        action: UPDATE_PRIORITY_TASK,
      }),
    [dispatch],
  )

  return [mutate, { isLoading: isUpdateLoading, error: updateError }]
}

export default useUpdatePriorityTaskMutation
